import { apiClient } from "@/App";

const toKey = (value) => {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const raw = atob((value + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const currentSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/");
  return reg ? reg.pushManager.getSubscription() : null;
};

export const enablePush = async () => {
  if (!pushSupported()) throw new Error("This browser does not support push notifications. On iPhone, add the app to your Home Screen first.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notification permission was not granted");
  const reg = (await navigator.serviceWorker.getRegistration("/")) || (await navigator.serviceWorker.register("/sw.js", { scope: "/" }));
  await navigator.serviceWorker.ready;
  const { data } = await apiClient.get("/push/public-key");
  const sub = (await reg.pushManager.getSubscription()) ||
    (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.publicKey) }));
  await apiClient.post("/push/subscribe", sub.toJSON());
  return sub;
};

export const disablePush = async () => {
  const sub = await currentSubscription();
  if (!sub) return;
  await apiClient.post("/push/unsubscribe", { endpoint: sub.endpoint });
  await sub.unsubscribe();
};
